<script lang="ts">
	import type { ICoinDetails } from 'customTypes/coinDetails';
	import NoIcon from 'assets/svg/noIcon.svg?url';
	import PercentageChange from 'components/PercentageChange/PercentageChange.svelte';
	import activeCurrency from 'stores/activeCurrency';
	import formatNumber from 'utils/formatNumber';
	import { onErrorCoinLogo } from 'utils/onErrorCoinLogo';
	import userStore from 'stores/user';
	import { onMount } from 'svelte';
	import formatCoinPrice from 'utils/formatCoinPrice';
	import PriceTooltip from 'components/PriceTooltip/PriceTooltip.svelte';
	import getClientWidth from 'utils/getClientWidth';

	export let data: ICoinDetails;
	export let dark: boolean;

	$: currencyData = $activeCurrency;
	$: isActiveCurrencyCrypto = ['BTC', 'ETH'].includes(currencyData.currency.toUpperCase());
	$: isUserLoggedIn = $userStore.isLoggedIn;
	$: alignRight = false;

	onMount(async () => {
		calculateViewportWidth();
		window.addEventListener('resize', calculateViewportWidth);
		return () => {
			window.removeEventListener('resize', calculateViewportWidth);
		};
	});

	// TODO: isMobile
	function calculateViewportWidth() {
		const viewportWidth = getClientWidth();
		alignRight = viewportWidth >= 320 && viewportWidth <= 767;
	}
</script>

<div class="wrapper" class:dark>
	<div class="coin-info" class:logged={isUserLoggedIn}>
		{#if data.stats.logo_url}
			<img
				src={data.stats.logo_url}
				class="coin-icon center"
				alt=""
				width="40"
				height="40"
				on:error={onErrorCoinLogo}
			/>
		{:else}
			<img src={NoIcon} class="coin-icon center" alt="" width="40" height="40" />
		{/if}
		<h1 class="name">{data.stats.name}</h1>
		<p class="label text-grey">{data.stats.symbol}</p>
		<p class="rank text-grey">{data.stats.rank ? `#${data.stats.rank} rank` : 'No rank'}</p>
	</div>

	<div class="price-text text-grey">
		<div class="price-wrapper" class:column={isActiveCurrencyCrypto}>
			<p class="description">{data.stats.symbol} to {currencyData.currency}</p>

			<p class="price">
				<PriceTooltip
					class="price-tooltip"
					verticalAlign="flex-end"
					tooltipAlign={alignRight ? 'right' : 'left'}
					price={formatCoinPrice(
						formatNumber(
							Number(data.stats.price) * currencyData.price,
							currencyData.currency,
							false,
							isActiveCurrencyCrypto ? 'decimal' : 'currency',
						),
					)}
				/>
			</p>
		</div>

		<span class="btc-price" class:hide={isActiveCurrencyCrypto}
			>BTC {formatNumber(
				Number(data.stats.price) * data.usdToBtcPrice,
				currencyData.currency,
				false,
				'decimal',
			)}</span
		>
	</div>

	<div class="change-wrapper">
		<p class="day-change text-grey">24H {data.stats.symbol} price</p>
		<div class="day-change-wrapper">
			<PercentageChange
				class="change"
				type="currency"
				dayChange={Number(data.stats['1d']?.price_change) * $activeCurrency.price || 0}
				{dark}
			/>
			<PercentageChange
				type="percentage"
				dayChange={Number(data.stats['1d']?.price_change_pct)}
				{dark}
			/>
		</div>
	</div>
</div>

<style lang="scss">
	@import 'coinInfo';
</style>
